module.exports = __webpack_public_path__ + "Roboto-Medium-webfont.1d2af757de4340d6b644.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/fonts/roboto/Roboto-Medium-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Medium-webfont.ttf
// module chunks = 2